import { Form, Button } from 'react-bootstrap';
import { ChevronsDownUp, ArrowUp, ArrowDown } from 'lucide-react';
import type { PaginationState, SortState, SortField } from '../models/types';

interface ProductTableHeaderProps {
  readonly productCount: number;
  readonly pagination: PaginationState;
  readonly onPageSizeChange: (limit: number) => void;
  readonly expandedCount: number;
  readonly onCollapseAll: () => void;
  readonly sort: SortState;
  readonly onSortChange: (field: SortField) => void;
}

export function ProductTableHeader({
  productCount,
  pagination,
  onPageSizeChange,
  expandedCount,
  onCollapseAll,
  sort,
  onSortChange,
}: ProductTableHeaderProps) {
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontSize: '0.85rem' }}>
          {productCount > 0 ? `Showing ${productCount} products` : 'No products loaded'}
        </span>
        {expandedCount > 0 && (
          <span style={{ fontSize: '0.75rem', color: '#888' }}>
            ({expandedCount} expanded)
          </span>
        )}
      </div>
      <div className="d-flex align-items-center gap-2">
        {expandedCount > 0 && (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onCollapseAll}
            style={{ fontSize: '0.75rem', padding: '2px 8px' }}
          >
            <ChevronsDownUp size={12} className="me-1" />
            Collapse All
          </Button>
        )}
        <Form.Select
          size="sm"
          value={sort.field}
          onChange={(e) => onSortChange(e.target.value as SortField)}
          style={{ width: 'auto', backgroundColor: '#333', color: '#fff', border: '1px solid #555' }}
        >
          <option value="sku">Sort: SKU</option>
          <option value="brand">Sort: Brand</option>
          <option value="name">Sort: Name</option>
          <option value="modifiedAt">Sort: Modified</option>
          <option value="humanDecidedAt">Sort: Actioned</option>
        </Form.Select>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => onSortChange(sort.field)}
          style={{ fontSize: '0.75rem', padding: '4px 8px' }}
          title={sort.direction === 'asc' ? 'Ascending' : 'Descending'}
        >
          {sort.direction === 'asc' ? <ArrowUp size={12} /> : <ArrowDown size={12} />}
        </Button>
        <Form.Select
          size="sm"
          value={pagination.limit}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          style={{ width: 'auto', backgroundColor: '#333', color: '#fff', border: '1px solid #555' }}
        >
          <option value={50}>50 / load</option>
          <option value={100}>100 / load</option>
        </Form.Select>
      </div>
    </div>
  );
}

